import { render, staticRenderFns } from "./SparePartTaskId.vue?vue&type=template&id=9261227a&scoped=true"
import script from "./SparePartTaskId.vue?vue&type=script&lang=ts"
export * from "./SparePartTaskId.vue?vue&type=script&lang=ts"
import style0 from "./SparePartTaskId.vue?vue&type=style&index=0&id=9261227a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9261227a",
  null
  
)

export default component.exports